const patternPrefix = "__url_pattern__";
const urlPatterns = {
  media: (id) => `/-/media/${id}.ashx`,
  page: (id) => `/${patternPrefix}/?pageId=${encodeURIComponent(id)}`,
  resource: (id) => `/${patternPrefix}/?resourceId=${encodeURIComponent(id)}`,
  element: (id) => `/${patternPrefix}/?elementId=${encodeURIComponent(id)}`
};
function extractPatternFromUrl(href) {
  try {
    const url = new URL(href, window.location.href);
    if (url.pathname !== `/${patternPrefix}/`) {
      const isElementLink = url.pathname.includes("learningObject");
      if (isElementLink) {
        return { elementId: url.pathname.replace(/\/learningobject\//gi, "") };
      }
      return { href };
    }
    const pageId = url.searchParams.get("pageId");
    const elementId = url.searchParams.get("elementId");
    const resourceId = url.searchParams.get("resourceId");
    if (pageId) {
      return { pageId };
    }
    if (elementId) {
      return { elementId };
    }
    if (resourceId) {
      return { resourceId };
    }
    return { href };
  } catch {
    return { href };
  }
}

export { extractPatternFromUrl, urlPatterns };
//# sourceMappingURL=constants.url-patterns.js.map
